.flash-banner-cta-container {
    display: flex;
    align-items: center;
    margin-left: 16px;
    white-space: nowrap;
}
